import { render } from "./FamilySection.vue?vue&type=template&id=3e0b590b"
import script from "./FamilySection.vue?vue&type=script&lang=js"
export * from "./FamilySection.vue?vue&type=script&lang=js"

import "./FamilySection.vue?vue&type=style&index=0&id=3e0b590b&lang=css"

import exportComponent from "/Users/adrianfraczak/Projects/Freaz/rk/rk.off-vue/rk.off-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__